import { render, staticRenderFns } from "./PageNav.vue?vue&type=template&id=6a12cd8b"
import script from "./PageNav.vue?vue&type=script&lang=js"
export * from "./PageNav.vue?vue&type=script&lang=js"
import style0 from "./PageNav.vue?vue&type=style&index=0&id=6a12cd8b&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports